<template>
  <div :key="cardSkeletonKey" class="product-card-skeleton">
    <!-- Image -->
    <SkeletonProductImage />
    <!-- Brand -->
    <AtomicUiSkeleton width="60%" height="18px" class="margin-top-xs" />
    <!-- Name -->
    <AtomicUiSkeleton width="100%" height="18px" :style="skeletonLineStyle" />
    <AtomicUiSkeleton width="60%" height="18px" :style="skeletonLineStyle" />
    <!-- Color, Size -->
    <AtomicUiSkeleton width="45%" height="18px" class="margin-top-xs" />
    <!-- Price -->
    <AtomicUiSkeleton width="28%" height="18px" class="margin-top-xs" />
    <AtomicUiSkeleton width="28%" height="18px" :style="skeletonLineStyle" />
    <!-- Badge -->
    <AtomicUiSkeleton width="45%" height="18px" class="margin-top-xs" />
    <!-- Buttons -->
    <div class="grid-x margin-top-m">
      <div v-if="isAuthenticated" class="cell small-12 medium-12 large-4 small-padding-right-z large-padding-right-xxs">
        <!-- Move Button -->
        <AtomicUiSkeleton width="100%" height="50px" />
      </div>
      <div class="cell small-12 medium-12 large-8 small-padding-top-xxs large-padding-top-z">
        <!-- Add to Bag Button -->
        <AtomicUiSkeleton width="100%" height="50px" />
      </div>
    </div>
  </div>
</template>

<script setup>
const cardSkeletonKey = ref(1);
const { isAuthenticated } = useWishlists();

const skeletonLineStyle = {
  'margin-top': 'var(--skeleton-margin-top, 4px)',
};

onMounted(() => {
  cardSkeletonKey.value += 1;
});
</script>

<style lang="scss" scoped>
.product-card-skeleton {
  --skeleton-margin-top: #{rem-calc(4px)};
}
</style>
